export default "__VITE_ASSET__BYEtiYBh__"